import { useState, useContext, Fragment } from 'react'
import classnames from 'classnames'
import Avatar from '@components/avatar'
import { useSkin } from '@hooks/useSkin'
import useJwt from '@src/auth/jwt/useJwt'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { toast, Slide } from 'react-toastify'
import { handleLogin } from '@auth/redux/actions'
import { AbilityContext } from '@src/utility/context/Can'
import { Link, useHistory } from 'react-router-dom'
import { LogIn, Sun, X } from 'react-feather'
import InputPasswordToggle from '@components/input-password-toggle'
import { isObjEmpty } from '@utils'
import { Row, Col, CardImg, CardText, Form, Input, FormGroup, Label, Button, CardTitle } from 'reactstrap'
import '@styles/base/pages/page-auth.scss'
import { useCustomForm } from '../../../utility/hooks/useCustomForm'

const ToastContent = ({ title, color, message, Icono }) => (
  <Fragment>
    <div className='toastify-header'>
      <div className='title-wrapper'>
        <Avatar size='sm' color={color} icon={<Icono size={12} />} />
        <h6 className='toast-title font-weight-bold'>{title}</h6>
      </div>
    </div>
    <div className='toastify-body'>
      <span>{message}</span>
    </div>
  </Fragment>
)

const Login = () => {
  const ability = useContext(AbilityContext)
  const dispatch = useDispatch()
  const history = useHistory()
  const { register, errors, handleSubmit } = useForm()
  const { form, onChange } = useCustomForm({})
  const logoLogin = require('@src/assets/images/backgrounds/nologo.png').default

  const onSubmit = () => {
    if (isObjEmpty(errors)) {
      useJwt
        .login(form)
        .then(res => {
          const { data } = res
          const toastAnimation = { transition: Slide, hideProgressBar: true, autoClose: 2000 }
          if (data.status === 401) {
            toast.error(
              <ToastContent
                title={'Acceso denegado'}
                message={'No se han podido validar los datos de acceso'}
                color='danger'
                Icono={X} />, toastAnimation)
            return
          }
          if (data.req === true) {
            toast.success(
              <ToastContent
                title={`Bienvenido/a`}
                message={'!Que tengas un buen día!'}
                color='yellow'
                Icono={Sun} />, toastAnimation)
            history.push('/greatings')
            return
          }
          if (data.req === false) {
            toast.error(
              <ToastContent
                title={'Tu cuenta no ha sido confirmada'}
                message={'Por favor revisa tu bandeja de entrada.'}
                color='danger'
                Icono={X}
              />,
              toastAnimation
            )
            return
          }
          dispatch(handleLogin(data))
          ability.update(data.ability)
          toast.success(
            <ToastContent
              title={`Bienvenido/a`}
              message={'!Que tengas un buen día!'}
              color='primary'
              Icono={Sun} />, toastAnimation
          )
          history.push('/domains')
        })

    }
  }


  return (
    <div>
      <div className="d-block mx-3 p-3 text-center ">
        <div className='d-inline-block d-lg-flex d-xl-flex justify-content-between'>
          <div>
            <CardImg src={logoLogin} style={{ width: '125px' }} />
          </div>
          <div>
            <Link to='/register'>
              <span className='text-black'>¿Nuevo en Klinnic? <span className='text-primary'>Registrate</span></span>
            </Link>
          </div>
        </div>
      </div>
      <div className='auth-wrapper text-center'>
        <div className='mx-1 mx-auto auth-login-form'>
          <div className='mx-1'>
            <h1 className='text-black' >
              Inicia sesión en Klinnic
            </h1>
            <span className='text-black'>Rellena el formulario con tus datos de registro.</span>
          </div>

          <div className='mt-5 mx-1'>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className='mt-3'>
                <Label className='form-label text-left' for='email' style={{ fontFamily: 'Poppins-Bold' }}>
                  Correo electrónico
                </Label>
                <Input
                  autoFocus
                  id='email'
                  name='email'
                  placeholder='Email'
                  onChange={onChange}
                  className={`${classnames({ 'is-invalid': errors['email'] })} login-input`}
                  innerRef={register({ required: true, validate: value => value !== '' })}
                />
              </div>
              <div className='mt-3'>
                <Label className='form-label text-left' for='login-password' style={{ fontFamily: 'Poppins-Bold' }}>
                  Contraseña
                </Label>
                <InputPasswordToggle
                  id='password'
                  name='password'
                  className='input-group-merge mb-2 login-input'
                  htmlFor='merge-password'
                  onChange={onChange}
                  innerRef={register({ required: true, validate: value => value !== '' })}
                />
              </div>

              <Button.Ripple
                className="login-button "
                color='primary'
                type='submit'
                outline
                block
                style={{ fontFamily: 'Poppins-Bold' }}
              >
                Iniciar sesión
              </Button.Ripple>

              <div className='mt-1'>
                <Link to='/forgot-password'>
                  <small>¿Olvidaste la contraseña?</small>
                </Link>
              </div>

            </Form>
          </div >

        </div >
      </div >
    </div >
  )
}

export default Login